export default "__VITE_ASSET__6d600aea__"